import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class SidebarItem extends AuxiliumComponent {
	constructor() {
		super();

		this.link = this.getAttribute("link") ?? "";
		this.icon = this.getAttribute("icon") ?? "";
	}

	parsedCallback() {
		if (this.link) {
			this.appendChild(document.createElementWithContents("chip-button", this.childNodes, {
				link: this.link,
				variation: "sidebar",
				icon: this.icon
			}));

			this.#UpdateActiveState();
		}
	}

	#UpdateActiveState() {
		const fullURL = Browser.ResolveRelativeURL(this.link);

		let isCurrent = location.toString().toLowerCase().startsWith(fullURL.toLowerCase()),
			markActive = isCurrent;

		if (isCurrent) {
			const pathCount = Browser.GetPaths(fullURL).length,
				list = this.closest("ul");

			[...list.querySelectorAll("chip-button")].filter(x => x !== this)
				.forEach(x => {
					const alsoMatches = location.toString().toLowerCase().startsWith(Browser.ResolveRelativeURL(x.link).toLowerCase());

					if (alsoMatches) {
						x.active = Browser.GetPaths(Browser.ResolveRelativeURL(x.link)).length > pathCount;

						if (x.active) {
							markActive = false;
						}
					} else {
						x.active = false;
					}
				});

			this.addEventListener("parsed", () => {
				if (list.offsetTop + list.offsetHeight <= this.offsetTop) {
					list.scrollTo({ top: this.offsetTop });
				}
			});
		}

		this.querySelector("chip-button").active = markActive;
	}
}